<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>Select manufacturer</h1>
                        </div>
                    </div>

                    <!-- Options -->
                    <div class="col-12">
                        <div class="card-grid grid-col-2 row">
                            <div class="selectable-card"
                                 v-for="make in makes"
                                 :key="make.id"
                                 @click="selectMake(make)"
                                 :class="{'active': makeIsActive(make)}">
                                <div class="card-body">
                                    <div class="card-img logo">
                                        <img class="logo" :src="make.image.path" :alt="make.title">
                                    </div>
                                    <p>
                                        {{ make.title }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link v-if="!store" :to="{ name: 'postcodeSearch'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <button @click="nextStep()" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !makeHasBeenSelected}">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                </div>
            </footer>
        </div>

        <!-- Make unavailable modal -->
        <make-unavailable-modal></make-unavailable-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "DeviceMake",

        mounted() {
            this.loadMakes();
            this.checkCanBeOnPage();
        },

        computed: {
            ...mapGetters(['selectedMakeId', 'bookingPostcode', 'carrierDetails', 'onlyOfferSamsung', 'makes', 'makeHasBeenSelected', 'makeIsActive', 'requiresStore', 'store']),
        },

        methods: {
            ...mapActions(['checkBookingIsComplete', 'loadMakes', 'selectMake']),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.store && !this.bookingPostcode) {
                        this.$router.push({name: 'postcodeSearch'});
                    }

                    if (this.onlyOfferSamsung) {
                        this.$router.push({name: 'deviceType'});
                    }
                });
            },

            nextStep() {
                if ((this.onlyOfferSamsung) && this.selectedMakeId === 1) {
                    return this.$bvModal.show("make-unavailable-modal");
                }

                this.$router.push({name: 'deviceType'})
            }
        }
    }
</script>

<style scoped>

</style>